//* Libraries imports
import { useNavigate, useParams } from 'react-router-dom';

//* Hooks imports
import { useGetProcessById } from '../../../../hooks/queries/process/use-get-process';

//* Components imports
import { ViewHeaderProcess } from '../../../ProcessView/view/_components/view-header-process';
import { ViewListCardResource } from "./view-list-card-resource";
import { ErrorMessages } from '../../../../component/common/ErrorMessages';
import { ResourceQuestionTableNew } from './table/index';
import { ProcessStatus } from '../../../../component/common/ProcessStatus';
import { ResourceListSkeleton } from '../../../../skeleton/ResourceListSkeleton';

export function Content() {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const processId = id ? parseInt(id) : 0;
  const processQuery = useGetProcessById(processId);
  const { isLoading, isError, data: processResponse } = processQuery;

  if (!processId) {
    navigate(-1);
    return null;
  }

  const handleBack = () => {
    navigate(`/process/${processId}`);
  };  const renderMainContent = () => {
    const process = processResponse!.data!;
      // Check if process is finished
    if (!process.isFinished) {
      return (
        <div className="d-flex justify-content-center align-items-center min-vh-100 w-100">
          <ProcessStatus
            type="in-progress"
            title="Processo em Andamento"
            subtitle={process.name}
            message="Este processo seletivo ainda não foi finalizado. Os recursos estarão disponíveis para visualização assim que o processo for concluído."
            actionLabel="Voltar ao Processo"
            onAction={handleBack}
          />
        </div>
      );
    }

    return (
      <div className="w-100">
        <ViewHeaderProcess
          processName={process?.name}
          handleBack={handleBack}
          isOnline={process?.online}
          startDate={process?.start?.human?.date}
          endDate={process?.end?.human?.date}
          collegeName={process?.college?.name}
        />

        <ViewListCardResource 
          processId={processId} 
          faculdadePermissions={process?.faculdadePermissions}
        />        
        
        <ResourceQuestionTableNew processId={id!} />
      </div>
    );
  };
  
  return isLoading ? (
    <ResourceListSkeleton />
  ) : isError || !processResponse?.success || !processResponse?.data ? (
    <ErrorMessages
      messages={[
        processResponse?.message ||
          "Não foi possível carregar os detalhes do processo.",
      ]}
      clearErrors={handleBack}
    />
  ) : (
    renderMainContent()
  );
}